import {LoadingIndicator}               from '../../lib/iprs-react-library/src/index.js';
/*
 * A component to display a list of templates and an option to apply to more 
 * than one week.
 */

import React, {useState}     from 'react'

import {getWeekStartEnd}                from '../../lib/iprs-react-library/src/index.js';

const TemplateApply = ({calendarApi, partyID, start, api, done, setError, state}) => {
    
    const { template: { templates, hidden } }         = state
    
    /* The list of templates now comes from the central application state.*/
    const templateList = templates.filter( t => !hidden.includes( t.id ) );
    const [templateID,   setTemplateID]         = useState(templateList.length? templateList[0].id: 0);
    const [weekCount,    setWeekCount]          = useState(1)
    
    const [loading, setLoading]                 = useState(false)
    
    const handleChange = e => {
        
        if(e.target.name === 'weeksSelect'){
            setWeekCount( Number.parseInt( e.target.value, 10 ) )
        }
        if(e.target.name === 'templateSelect'){
            setTemplateID( Number.parseInt( e.target.value, 10 ) )
        }
    }
    
    
    const handleClick = e => {
        
        e.preventDefault()
        
        setError( null )
        
        /* take the start of the period selected and get the beginning and end 
         * of the current week*/
        const [startTime, finishTime] = getWeekStartEnd( start, weekCount )
        setLoading(true);
        
        api.applyRotaTemplate(templateID, partyID, startTime, finishTime)
            .then( () => {
                setLoading(false)
                if(calendarApi.unselect){
                    calendarApi.unselect() // clear date selection
                }
                done()
            } )
            .catch(e => {
                setLoading(false)
                if(calendarApi.unselect){
                    calendarApi.unselect() // clear date selection
                }
            
                setError( e.apiText )
            })
    }
    
    return (
        <div >
        
            <h2>Apply Template</h2>
            <label htmlFor='templateSelect' >Select the template:</label>
            <select name='templateSelect' onChange={handleChange} >
                { templateList.map( t => (<option key={t.id} 
                value={t.id} >{t.Name}</option>) ) }
            </select>
            <label>For how many weeks?</label>
            <select name='weeksSelect' onChange={handleChange} value={weekCount} >
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
                <option value='4'>4</option>
            </select>
            <p></p>
            <button onClick={handleClick} >Apply</button><span> </span><span> </span>
            <a href='.' onClick={e=>{e.preventDefault();done()}} >Cancel</a>
            <LoadingIndicator loading={loading} />      
        </div>
    )
}

export default TemplateApply
